/** Синхронизировать с версией внизу страницы /privacy при обновлении политики. */
export const COOKIE_AND_PRIVACY_POLICY_VERSION = '2026-04-01';

export const COOKIE_CONSENT_STORAGE_KEY = 'pps_cookie_privacy_consent';

export type StoredCookieConsent = {
  v: string;
  acceptedAt: string;
};

export function readStoredConsent(): StoredCookieConsent | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredCookieConsent;
    if (parsed?.v === COOKIE_AND_PRIVACY_POLICY_VERSION && typeof parsed.acceptedAt === 'string') {
      return parsed;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function writeConsent(): void {
  try {
    const payload: StoredCookieConsent = {
      v: COOKIE_AND_PRIVACY_POLICY_VERSION,
      acceptedAt: new Date().toISOString(),
    };
    window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}
